import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Checkbox, Row, TextButton, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useViewLegalTerms } from '~/components/LegalTermsDropdown/hooks/useViewLegalTerms';
import { useLocaleKeys } from '~/i18n';
import { fromRelationshipLegalTerms } from '~/models/legal-terms/translator';
export const GetTermsOfServiceTID = (parentTestId)=>getTestIds(parentTestId);
export const TermsOfService = (props)=>{
    const { legalTermsDocument, checked, onCheckedChange, vendorId, invoiceId, testId } = props;
    const { TermsOfServiceTestIds } = useMemo(()=>GetTermsOfServiceTID(testId), [
        testId
    ]);
    const { t } = useLocaleKeys();
    const { viewLegalTerms } = useViewLegalTerms({
        vendorBusinessId: vendorId,
        showDownloadButton: true
    });
    if (legalTermsDocument == null) return null;
    const viewerModel = fromRelationshipLegalTerms([
        legalTermsDocument
    ])[0];
    const handleCheckboxChange = (e)=>onCheckedChange(e.target.checked);
    const handleLinkClick = ()=>viewLegalTerms(viewerModel, invoiceId);
    return /*#__PURE__*/ _jsxs(Row, {
        testId: TermsOfServiceTestIds.Root(),
        gap: 8,
        alignItems: "center",
        children: [
            /*#__PURE__*/ _jsx(Checkbox, {
                testId: TermsOfServiceTestIds.Checkbox(),
                checked: checked,
                onChange: handleCheckboxChange,
                bi: {
                    name: 'agree_to_terms_of_service'
                }
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph2",
                children: t.adHocInvoiceApproval.termsOfService.agreeLabel()
            }),
            /*#__PURE__*/ _jsx(TextButton, {
                bi: {
                    name: 'ad_hoc_invoice_view_terms'
                },
                testId: TermsOfServiceTestIds.Link(),
                variant: "paragraph2",
                onClick: handleLinkClick,
                children: t.adHocInvoiceApproval.termsOfService.linkLabel()
            })
        ]
    });
};
